//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class SalaryControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/rewarding";
    }

    /**
     * Capabilities=view-employment; Scopes=any
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param includeHistory (optional) 
     * @param uids (optional) 
     * @param employeeIds (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param sort (optional) 
     */
    getAllMains(order: Order | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, includeHistory: boolean | undefined, uids: string[] | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, sort: string[] | undefined): Promise<SalaryListResultDto> {
        let url_ = this.baseUrl + "/salaries?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (includeHistory === null)
            throw new Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        if (uids === null)
            throw new Error("The parameter 'uids' cannot be null.");
        else if (uids !== undefined)
            uids && uids.forEach(item => { url_ += "uids=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMains(_response);
        });
    }

    protected processGetAllMains(response: Response): Promise<SalaryListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalaryListResultDto>(null as any);
    }

    /**
     * Capabilities=view-workflow; Scopes=any
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param includeHistory (optional) 
     * @param uids (optional) 
     * @param employeeIds (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param workflowStatuses (optional) 
     * @param workflowHandlers (optional) 
     * @param sort (optional) 
     */
    getAllProposals(order: Order2 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, includeHistory: boolean | undefined, uids: string[] | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, workflowStatuses: WorkflowStatuses[] | undefined, workflowHandlers: number[] | undefined, sort: string[] | undefined): Promise<SalaryListResultDto2> {
        let url_ = this.baseUrl + "/salary-proposals?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (includeHistory === null)
            throw new Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        if (uids === null)
            throw new Error("The parameter 'uids' cannot be null.");
        else if (uids !== undefined)
            uids && uids.forEach(item => { url_ += "uids=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (workflowStatuses === null)
            throw new Error("The parameter 'workflowStatuses' cannot be null.");
        else if (workflowStatuses !== undefined)
            workflowStatuses && workflowStatuses.forEach(item => { url_ += "workflowStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (workflowHandlers === null)
            throw new Error("The parameter 'workflowHandlers' cannot be null.");
        else if (workflowHandlers !== undefined)
            workflowHandlers && workflowHandlers.forEach(item => { url_ += "workflowHandlers=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProposals(_response);
        });
    }

    protected processGetAllProposals(response: Response): Promise<SalaryListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalaryListResultDto2>(null as any);
    }
}

export class AllowanceControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/rewarding";
    }

    /**
     * Capabilities=view-employment; Scopes=any
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param includeHistory (optional) 
     * @param uids (optional) 
     * @param employeeIds (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param sort (optional) 
     */
    getAllMains(order: Order3 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, includeHistory: boolean | undefined, uids: string[] | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, sort: string[] | undefined): Promise<AllowanceListResultDto> {
        let url_ = this.baseUrl + "/allowances?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (includeHistory === null)
            throw new Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        if (uids === null)
            throw new Error("The parameter 'uids' cannot be null.");
        else if (uids !== undefined)
            uids && uids.forEach(item => { url_ += "uids=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMains(_response);
        });
    }

    protected processGetAllMains(response: Response): Promise<AllowanceListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllowanceListResultDto>(null as any);
    }

    /**
     * Capabilities=view-workflow; Scopes=any
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param includeHistory (optional) 
     * @param uids (optional) 
     * @param employeeIds (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param workflowStatuses (optional) 
     * @param workflowHandlers (optional) 
     * @param sort (optional) 
     */
    getAllProposals(order: Order4 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, includeHistory: boolean | undefined, uids: string[] | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, workflowStatuses: WorkflowStatuses2[] | undefined, workflowHandlers: number[] | undefined, sort: string[] | undefined): Promise<AllowanceListResultDto2> {
        let url_ = this.baseUrl + "/allowance-proposals?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (includeHistory === null)
            throw new Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        if (uids === null)
            throw new Error("The parameter 'uids' cannot be null.");
        else if (uids !== undefined)
            uids && uids.forEach(item => { url_ += "uids=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (workflowStatuses === null)
            throw new Error("The parameter 'workflowStatuses' cannot be null.");
        else if (workflowStatuses !== undefined)
            workflowStatuses && workflowStatuses.forEach(item => { url_ += "workflowStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (workflowHandlers === null)
            throw new Error("The parameter 'workflowHandlers' cannot be null.");
        else if (workflowHandlers !== undefined)
            workflowHandlers && workflowHandlers.forEach(item => { url_ += "workflowHandlers=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProposals(_response);
        });
    }

    protected processGetAllProposals(response: Response): Promise<AllowanceListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllowanceListResultDto2>(null as any);
    }
}

export class BenefitControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/rewarding";
    }

    /**
     * Capabilities=view-employment; Scopes=any
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param includeHistory (optional) 
     * @param uids (optional) 
     * @param employeeIds (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param sort (optional) 
     */
    getAllMains(order: Order5 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, includeHistory: boolean | undefined, uids: string[] | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, sort: string[] | undefined): Promise<BenefitListResultDto> {
        let url_ = this.baseUrl + "/benefits?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (includeHistory === null)
            throw new Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        if (uids === null)
            throw new Error("The parameter 'uids' cannot be null.");
        else if (uids !== undefined)
            uids && uids.forEach(item => { url_ += "uids=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMains(_response);
        });
    }

    protected processGetAllMains(response: Response): Promise<BenefitListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BenefitListResultDto>(null as any);
    }

    /**
     * Capabilities=view-workflow; Scopes=any
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param includeHistory (optional) 
     * @param uids (optional) 
     * @param employeeIds (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param workflowStatuses (optional) 
     * @param workflowHandlers (optional) 
     * @param sort (optional) 
     */
    getAllProposals(order: Order6 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, includeHistory: boolean | undefined, uids: string[] | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, workflowStatuses: WorkflowStatuses3[] | undefined, workflowHandlers: number[] | undefined, sort: string[] | undefined): Promise<BenefitListResultDto2> {
        let url_ = this.baseUrl + "/benefit-proposals?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (includeHistory === null)
            throw new Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        if (uids === null)
            throw new Error("The parameter 'uids' cannot be null.");
        else if (uids !== undefined)
            uids && uids.forEach(item => { url_ += "uids=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (workflowStatuses === null)
            throw new Error("The parameter 'workflowStatuses' cannot be null.");
        else if (workflowStatuses !== undefined)
            workflowStatuses && workflowStatuses.forEach(item => { url_ += "workflowStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (workflowHandlers === null)
            throw new Error("The parameter 'workflowHandlers' cannot be null.");
        else if (workflowHandlers !== undefined)
            workflowHandlers && workflowHandlers.forEach(item => { url_ += "workflowHandlers=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProposals(_response);
        });
    }

    protected processGetAllProposals(response: Response): Promise<BenefitListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BenefitListResultDto2>(null as any);
    }
}

export class IncentiveControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/rewarding";
    }

    /**
     * Capabilities=view-employment; Scopes=any
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param includeHistory (optional) 
     * @param categories (optional) 
     * @param uids (optional) 
     * @param employeeIds (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param sort (optional) 
     */
    getAllMains(order: Order7 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, includeHistory: boolean | undefined, categories: Categories[] | undefined, uids: string[] | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, sort: string[] | undefined): Promise<IncentiveListResultDto> {
        let url_ = this.baseUrl + "/incentives?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (includeHistory === null)
            throw new Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        if (categories === null)
            throw new Error("The parameter 'categories' cannot be null.");
        else if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "categories=" + encodeURIComponent("" + item) + "&"; });
        if (uids === null)
            throw new Error("The parameter 'uids' cannot be null.");
        else if (uids !== undefined)
            uids && uids.forEach(item => { url_ += "uids=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMains(_response);
        });
    }

    protected processGetAllMains(response: Response): Promise<IncentiveListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncentiveListResultDto>(null as any);
    }

    /**
     * Capabilities=view-workflow; Scopes=any
     * @param order (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lang (optional) 
     * @param includeHistory (optional) 
     * @param uids (optional) 
     * @param employeeIds (optional) 
     * @param unitIds (optional) 
     * @param roles (optional) 
     * @param workflowStatuses (optional) 
     * @param workflowHandlers (optional) 
     * @param sort (optional) 
     */
    getAllProposals(order: Order8 | undefined, offset: number | undefined, limit: number | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | undefined, includeHistory: boolean | undefined, uids: string[] | undefined, employeeIds: number[] | undefined, unitIds: number[] | undefined, roles: string[] | undefined, workflowStatuses: WorkflowStatuses4[] | undefined, workflowHandlers: number[] | undefined, sort: string[] | undefined): Promise<IncentiveListResultDto2> {
        let url_ = this.baseUrl + "/incentive-proposals?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (includeHistory === null)
            throw new Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        if (uids === null)
            throw new Error("The parameter 'uids' cannot be null.");
        else if (uids !== undefined)
            uids && uids.forEach(item => { url_ += "uids=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitIds === null)
            throw new Error("The parameter 'unitIds' cannot be null.");
        else if (unitIds !== undefined)
            unitIds && unitIds.forEach(item => { url_ += "unitIds=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (workflowStatuses === null)
            throw new Error("The parameter 'workflowStatuses' cannot be null.");
        else if (workflowStatuses !== undefined)
            workflowStatuses && workflowStatuses.forEach(item => { url_ += "workflowStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (workflowHandlers === null)
            throw new Error("The parameter 'workflowHandlers' cannot be null.");
        else if (workflowHandlers !== undefined)
            workflowHandlers && workflowHandlers.forEach(item => { url_ += "workflowHandlers=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProposals(_response);
        });
    }

    protected processGetAllProposals(response: Response): Promise<IncentiveListResultDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncentiveListResultDto2>(null as any);
    }
}

export class RewardControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/rewarding";
    }

    bulkProposalAction(action: Action, body: BulkProposalActionInput): Promise<void> {
        let url_ = this.baseUrl + "/proposals/{action}";
        if (action === undefined || action === null)
            throw new Error("The parameter 'action' must be defined.");
        url_ = url_.replace("{action}", encodeURIComponent("" + action));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkProposalAction(_response);
        });
    }

    protected processBulkProposalAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnumValueDto implements IEnumValueDto {
    group!: string;
    code!: string;
    language!: string | undefined;
    name!: string;

    constructor(data?: IEnumValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnumValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["code"] = this.code;
        data["language"] = this.language;
        data["name"] = this.name;
        return data;
    }
}

export interface IEnumValueDto {
    group: string;
    code: string;
    language: string | undefined;
    name: string;
}

export class SupersededDto implements ISupersededDto {
    time!: Date;
    reason!: string;
    userId!: number;

    constructor(data?: ISupersededDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): SupersededDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupersededDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ISupersededDto {
    time: Date;
    reason: string;
    userId: number;
}

export class RewardAttachmentDto implements IRewardAttachmentDto {
    id!: number;
    name!: string;
    path!: string;

    constructor(data?: IRewardAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): RewardAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["path"] = this.path;
        return data;
    }
}

export interface IRewardAttachmentDto {
    id: number;
    name: string;
    path: string;
}

export class SalaryProposalInfoDto implements ISalaryProposalInfoDto {
    status!: EnumValueDto;
    reason!: EnumValueDto;
    proposedChange!: number;
    proposedChangePct!: number;
    hrId?: number;
    higherManagerId?: number;
    managerId?: number;

    constructor(data?: ISalaryProposalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.status = data.status && !(<any>data.status).toJSON ? new EnumValueDto(data.status) : <EnumValueDto>this.status;
            this.reason = data.reason && !(<any>data.reason).toJSON ? new EnumValueDto(data.reason) : <EnumValueDto>this.reason;
        }
        if (!data) {
            this.status = new EnumValueDto();
            this.reason = new EnumValueDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] ? EnumValueDto.fromJS(_data["status"]) : new EnumValueDto();
            this.reason = _data["reason"] ? EnumValueDto.fromJS(_data["reason"]) : new EnumValueDto();
            this.proposedChange = _data["proposedChange"];
            this.proposedChangePct = _data["proposedChangePct"];
            this.hrId = _data["hrId"];
            this.higherManagerId = _data["higherManagerId"];
            this.managerId = _data["managerId"];
        }
    }

    static fromJS(data: any): SalaryProposalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryProposalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        data["proposedChange"] = this.proposedChange;
        data["proposedChangePct"] = this.proposedChangePct;
        data["hrId"] = this.hrId;
        data["higherManagerId"] = this.higherManagerId;
        data["managerId"] = this.managerId;
        return data;
    }
}

export interface ISalaryProposalInfoDto {
    status: IEnumValueDto;
    reason: IEnumValueDto;
    proposedChange: number;
    proposedChangePct: number;
    hrId?: number;
    higherManagerId?: number;
    managerId?: number;
}

export class SalaryDto implements ISalaryDto {
    id!: number;
    uid?: string;
    employeeId!: number;
    employmentId!: number;
    unitId!: number;
    positionId!: number;
    startDate?: Date;
    endDate?: Date;
    info?: string;
    amount?: number;
    taxableAmount?: number;
    frequency?: EnumValueDto;
    type?: EnumValueDto;
    category!: SalaryDtoCategory;
    enteredTime!: Date;
    enteredUserId?: number;
    superseded?: SupersededDto;
    isProposal!: boolean;
    attachment?: RewardAttachmentDto;
    salaryClass?: EnumValueDto;
    proposal?: SalaryProposalInfoDto;

    constructor(data?: ISalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.frequency = data.frequency && !(<any>data.frequency).toJSON ? new EnumValueDto(data.frequency) : <EnumValueDto>this.frequency;
            this.type = data.type && !(<any>data.type).toJSON ? new EnumValueDto(data.type) : <EnumValueDto>this.type;
            this.superseded = data.superseded && !(<any>data.superseded).toJSON ? new SupersededDto(data.superseded) : <SupersededDto>this.superseded;
            this.attachment = data.attachment && !(<any>data.attachment).toJSON ? new RewardAttachmentDto(data.attachment) : <RewardAttachmentDto>this.attachment;
            this.salaryClass = data.salaryClass && !(<any>data.salaryClass).toJSON ? new EnumValueDto(data.salaryClass) : <EnumValueDto>this.salaryClass;
            this.proposal = data.proposal && !(<any>data.proposal).toJSON ? new SalaryProposalInfoDto(data.proposal) : <SalaryProposalInfoDto>this.proposal;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.employeeId = _data["employeeId"];
            this.employmentId = _data["employmentId"];
            this.unitId = _data["unitId"];
            this.positionId = _data["positionId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.info = _data["info"];
            this.amount = _data["amount"];
            this.taxableAmount = _data["taxableAmount"];
            this.frequency = _data["frequency"] ? EnumValueDto.fromJS(_data["frequency"]) : <any>undefined;
            this.type = _data["type"] ? EnumValueDto.fromJS(_data["type"]) : <any>undefined;
            this.category = _data["category"];
            this.enteredTime = _data["enteredTime"] ? new Date(_data["enteredTime"].toString()) : <any>undefined;
            this.enteredUserId = _data["enteredUserId"];
            this.superseded = _data["superseded"] ? SupersededDto.fromJS(_data["superseded"]) : <any>undefined;
            this.isProposal = _data["isProposal"];
            this.attachment = _data["attachment"] ? RewardAttachmentDto.fromJS(_data["attachment"]) : <any>undefined;
            this.salaryClass = _data["salaryClass"] ? EnumValueDto.fromJS(_data["salaryClass"]) : <any>undefined;
            this.proposal = _data["proposal"] ? SalaryProposalInfoDto.fromJS(_data["proposal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["employeeId"] = this.employeeId;
        data["employmentId"] = this.employmentId;
        data["unitId"] = this.unitId;
        data["positionId"] = this.positionId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["info"] = this.info;
        data["amount"] = this.amount;
        data["taxableAmount"] = this.taxableAmount;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["category"] = this.category;
        data["enteredTime"] = this.enteredTime ? this.enteredTime.toISOString() : <any>undefined;
        data["enteredUserId"] = this.enteredUserId;
        data["superseded"] = this.superseded ? this.superseded.toJSON() : <any>undefined;
        data["isProposal"] = this.isProposal;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        data["salaryClass"] = this.salaryClass ? this.salaryClass.toJSON() : <any>undefined;
        data["proposal"] = this.proposal ? this.proposal.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISalaryDto {
    id: number;
    uid?: string;
    employeeId: number;
    employmentId: number;
    unitId: number;
    positionId: number;
    startDate?: Date;
    endDate?: Date;
    info?: string;
    amount?: number;
    taxableAmount?: number;
    frequency?: IEnumValueDto;
    type?: IEnumValueDto;
    category: SalaryDtoCategory;
    enteredTime: Date;
    enteredUserId?: number;
    superseded?: ISupersededDto;
    isProposal: boolean;
    attachment?: IRewardAttachmentDto;
    salaryClass?: IEnumValueDto;
    proposal?: ISalaryProposalInfoDto;
}

export class AllowanceProposalInfoDto implements IAllowanceProposalInfoDto {
    status!: EnumValueDto;
    hrId?: number;
    higherManagerId?: number;
    managerId?: number;

    constructor(data?: IAllowanceProposalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.status = data.status && !(<any>data.status).toJSON ? new EnumValueDto(data.status) : <EnumValueDto>this.status;
        }
        if (!data) {
            this.status = new EnumValueDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] ? EnumValueDto.fromJS(_data["status"]) : new EnumValueDto();
            this.hrId = _data["hrId"];
            this.higherManagerId = _data["higherManagerId"];
            this.managerId = _data["managerId"];
        }
    }

    static fromJS(data: any): AllowanceProposalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceProposalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["hrId"] = this.hrId;
        data["higherManagerId"] = this.higherManagerId;
        data["managerId"] = this.managerId;
        return data;
    }
}

export interface IAllowanceProposalInfoDto {
    status: IEnumValueDto;
    hrId?: number;
    higherManagerId?: number;
    managerId?: number;
}

export class AllowanceDto implements IAllowanceDto {
    id!: number;
    uid?: string;
    employeeId!: number;
    employmentId!: number;
    unitId!: number;
    positionId!: number;
    startDate?: Date;
    endDate?: Date;
    info?: string;
    amount?: number;
    taxableAmount?: number;
    frequency?: EnumValueDto;
    type?: EnumValueDto;
    category!: AllowanceDtoCategory;
    enteredTime!: Date;
    enteredUserId?: number;
    superseded?: SupersededDto;
    isProposal!: boolean;
    attachment?: RewardAttachmentDto;
    proposal?: AllowanceProposalInfoDto;

    constructor(data?: IAllowanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.frequency = data.frequency && !(<any>data.frequency).toJSON ? new EnumValueDto(data.frequency) : <EnumValueDto>this.frequency;
            this.type = data.type && !(<any>data.type).toJSON ? new EnumValueDto(data.type) : <EnumValueDto>this.type;
            this.superseded = data.superseded && !(<any>data.superseded).toJSON ? new SupersededDto(data.superseded) : <SupersededDto>this.superseded;
            this.attachment = data.attachment && !(<any>data.attachment).toJSON ? new RewardAttachmentDto(data.attachment) : <RewardAttachmentDto>this.attachment;
            this.proposal = data.proposal && !(<any>data.proposal).toJSON ? new AllowanceProposalInfoDto(data.proposal) : <AllowanceProposalInfoDto>this.proposal;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.employeeId = _data["employeeId"];
            this.employmentId = _data["employmentId"];
            this.unitId = _data["unitId"];
            this.positionId = _data["positionId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.info = _data["info"];
            this.amount = _data["amount"];
            this.taxableAmount = _data["taxableAmount"];
            this.frequency = _data["frequency"] ? EnumValueDto.fromJS(_data["frequency"]) : <any>undefined;
            this.type = _data["type"] ? EnumValueDto.fromJS(_data["type"]) : <any>undefined;
            this.category = _data["category"];
            this.enteredTime = _data["enteredTime"] ? new Date(_data["enteredTime"].toString()) : <any>undefined;
            this.enteredUserId = _data["enteredUserId"];
            this.superseded = _data["superseded"] ? SupersededDto.fromJS(_data["superseded"]) : <any>undefined;
            this.isProposal = _data["isProposal"];
            this.attachment = _data["attachment"] ? RewardAttachmentDto.fromJS(_data["attachment"]) : <any>undefined;
            this.proposal = _data["proposal"] ? AllowanceProposalInfoDto.fromJS(_data["proposal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AllowanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["employeeId"] = this.employeeId;
        data["employmentId"] = this.employmentId;
        data["unitId"] = this.unitId;
        data["positionId"] = this.positionId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["info"] = this.info;
        data["amount"] = this.amount;
        data["taxableAmount"] = this.taxableAmount;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["category"] = this.category;
        data["enteredTime"] = this.enteredTime ? this.enteredTime.toISOString() : <any>undefined;
        data["enteredUserId"] = this.enteredUserId;
        data["superseded"] = this.superseded ? this.superseded.toJSON() : <any>undefined;
        data["isProposal"] = this.isProposal;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        data["proposal"] = this.proposal ? this.proposal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAllowanceDto {
    id: number;
    uid?: string;
    employeeId: number;
    employmentId: number;
    unitId: number;
    positionId: number;
    startDate?: Date;
    endDate?: Date;
    info?: string;
    amount?: number;
    taxableAmount?: number;
    frequency?: IEnumValueDto;
    type?: IEnumValueDto;
    category: AllowanceDtoCategory;
    enteredTime: Date;
    enteredUserId?: number;
    superseded?: ISupersededDto;
    isProposal: boolean;
    attachment?: IRewardAttachmentDto;
    proposal?: IAllowanceProposalInfoDto;
}

export class BenefitProposalInfoDto implements IBenefitProposalInfoDto {
    status!: EnumValueDto;
    hrId?: number;
    higherManagerId?: number;
    managerId?: number;

    constructor(data?: IBenefitProposalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.status = data.status && !(<any>data.status).toJSON ? new EnumValueDto(data.status) : <EnumValueDto>this.status;
        }
        if (!data) {
            this.status = new EnumValueDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] ? EnumValueDto.fromJS(_data["status"]) : new EnumValueDto();
            this.hrId = _data["hrId"];
            this.higherManagerId = _data["higherManagerId"];
            this.managerId = _data["managerId"];
        }
    }

    static fromJS(data: any): BenefitProposalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitProposalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["hrId"] = this.hrId;
        data["higherManagerId"] = this.higherManagerId;
        data["managerId"] = this.managerId;
        return data;
    }
}

export interface IBenefitProposalInfoDto {
    status: IEnumValueDto;
    hrId?: number;
    higherManagerId?: number;
    managerId?: number;
}

export class BenefitDto implements IBenefitDto {
    id!: number;
    uid?: string;
    employeeId!: number;
    employmentId!: number;
    unitId!: number;
    positionId!: number;
    startDate?: Date;
    endDate?: Date;
    info?: string;
    amount?: number;
    taxableAmount?: number;
    frequency?: EnumValueDto;
    type?: EnumValueDto;
    category!: BenefitDtoCategory;
    enteredTime!: Date;
    enteredUserId?: number;
    superseded?: SupersededDto;
    isProposal!: boolean;
    attachment?: RewardAttachmentDto;
    proposal?: BenefitProposalInfoDto;

    constructor(data?: IBenefitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.frequency = data.frequency && !(<any>data.frequency).toJSON ? new EnumValueDto(data.frequency) : <EnumValueDto>this.frequency;
            this.type = data.type && !(<any>data.type).toJSON ? new EnumValueDto(data.type) : <EnumValueDto>this.type;
            this.superseded = data.superseded && !(<any>data.superseded).toJSON ? new SupersededDto(data.superseded) : <SupersededDto>this.superseded;
            this.attachment = data.attachment && !(<any>data.attachment).toJSON ? new RewardAttachmentDto(data.attachment) : <RewardAttachmentDto>this.attachment;
            this.proposal = data.proposal && !(<any>data.proposal).toJSON ? new BenefitProposalInfoDto(data.proposal) : <BenefitProposalInfoDto>this.proposal;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.employeeId = _data["employeeId"];
            this.employmentId = _data["employmentId"];
            this.unitId = _data["unitId"];
            this.positionId = _data["positionId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.info = _data["info"];
            this.amount = _data["amount"];
            this.taxableAmount = _data["taxableAmount"];
            this.frequency = _data["frequency"] ? EnumValueDto.fromJS(_data["frequency"]) : <any>undefined;
            this.type = _data["type"] ? EnumValueDto.fromJS(_data["type"]) : <any>undefined;
            this.category = _data["category"];
            this.enteredTime = _data["enteredTime"] ? new Date(_data["enteredTime"].toString()) : <any>undefined;
            this.enteredUserId = _data["enteredUserId"];
            this.superseded = _data["superseded"] ? SupersededDto.fromJS(_data["superseded"]) : <any>undefined;
            this.isProposal = _data["isProposal"];
            this.attachment = _data["attachment"] ? RewardAttachmentDto.fromJS(_data["attachment"]) : <any>undefined;
            this.proposal = _data["proposal"] ? BenefitProposalInfoDto.fromJS(_data["proposal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BenefitDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["employeeId"] = this.employeeId;
        data["employmentId"] = this.employmentId;
        data["unitId"] = this.unitId;
        data["positionId"] = this.positionId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["info"] = this.info;
        data["amount"] = this.amount;
        data["taxableAmount"] = this.taxableAmount;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["category"] = this.category;
        data["enteredTime"] = this.enteredTime ? this.enteredTime.toISOString() : <any>undefined;
        data["enteredUserId"] = this.enteredUserId;
        data["superseded"] = this.superseded ? this.superseded.toJSON() : <any>undefined;
        data["isProposal"] = this.isProposal;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        data["proposal"] = this.proposal ? this.proposal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBenefitDto {
    id: number;
    uid?: string;
    employeeId: number;
    employmentId: number;
    unitId: number;
    positionId: number;
    startDate?: Date;
    endDate?: Date;
    info?: string;
    amount?: number;
    taxableAmount?: number;
    frequency?: IEnumValueDto;
    type?: IEnumValueDto;
    category: BenefitDtoCategory;
    enteredTime: Date;
    enteredUserId?: number;
    superseded?: ISupersededDto;
    isProposal: boolean;
    attachment?: IRewardAttachmentDto;
    proposal?: IBenefitProposalInfoDto;
}

export class IncentivePaymentInfoDto implements IIncentivePaymentInfoDto {
    paymentDate!: Date;
    paymentPeriod?: string;
    paymentPeriodStartDate?: Date;
    paymentPeriodEndDate?: Date;
    recurrence?: number;
    approvalDate?: Date;

    constructor(data?: IIncentivePaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentPeriod = _data["paymentPeriod"];
            this.paymentPeriodStartDate = _data["paymentPeriodStartDate"] ? new Date(_data["paymentPeriodStartDate"].toString()) : <any>undefined;
            this.paymentPeriodEndDate = _data["paymentPeriodEndDate"] ? new Date(_data["paymentPeriodEndDate"].toString()) : <any>undefined;
            this.recurrence = _data["recurrence"];
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IncentivePaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncentivePaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentPeriod"] = this.paymentPeriod;
        data["paymentPeriodStartDate"] = this.paymentPeriodStartDate ? this.paymentPeriodStartDate.toISOString() : <any>undefined;
        data["paymentPeriodEndDate"] = this.paymentPeriodEndDate ? this.paymentPeriodEndDate.toISOString() : <any>undefined;
        data["recurrence"] = this.recurrence;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIncentivePaymentInfoDto {
    paymentDate: Date;
    paymentPeriod?: string;
    paymentPeriodStartDate?: Date;
    paymentPeriodEndDate?: Date;
    recurrence?: number;
    approvalDate?: Date;
}

export class IncentiveProposalInfoDto implements IIncentiveProposalInfoDto {
    status!: EnumValueDto;
    hrId?: number;
    higherManagerId?: number;
    managerId?: number;

    constructor(data?: IIncentiveProposalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.status = data.status && !(<any>data.status).toJSON ? new EnumValueDto(data.status) : <EnumValueDto>this.status;
        }
        if (!data) {
            this.status = new EnumValueDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] ? EnumValueDto.fromJS(_data["status"]) : new EnumValueDto();
            this.hrId = _data["hrId"];
            this.higherManagerId = _data["higherManagerId"];
            this.managerId = _data["managerId"];
        }
    }

    static fromJS(data: any): IncentiveProposalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncentiveProposalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["hrId"] = this.hrId;
        data["higherManagerId"] = this.higherManagerId;
        data["managerId"] = this.managerId;
        return data;
    }
}

export interface IIncentiveProposalInfoDto {
    status: IEnumValueDto;
    hrId?: number;
    higherManagerId?: number;
    managerId?: number;
}

export class IncentiveDto implements IIncentiveDto {
    id!: number;
    uid?: string;
    employeeId!: number;
    employmentId!: number;
    unitId!: number;
    positionId!: number;
    startDate?: Date;
    endDate?: Date;
    info?: string;
    amount?: number;
    taxableAmount?: number;
    frequency?: EnumValueDto;
    type?: EnumValueDto;
    category!: IncentiveDtoCategory;
    enteredTime!: Date;
    enteredUserId?: number;
    superseded?: SupersededDto;
    isProposal!: boolean;
    attachment?: RewardAttachmentDto;
    targetEarning?: number;
    bonusValue?: number;
    unitOfMeasure?: string;
    paymentInfo?: IncentivePaymentInfoDto;
    proposal?: IncentiveProposalInfoDto;

    constructor(data?: IIncentiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.frequency = data.frequency && !(<any>data.frequency).toJSON ? new EnumValueDto(data.frequency) : <EnumValueDto>this.frequency;
            this.type = data.type && !(<any>data.type).toJSON ? new EnumValueDto(data.type) : <EnumValueDto>this.type;
            this.superseded = data.superseded && !(<any>data.superseded).toJSON ? new SupersededDto(data.superseded) : <SupersededDto>this.superseded;
            this.attachment = data.attachment && !(<any>data.attachment).toJSON ? new RewardAttachmentDto(data.attachment) : <RewardAttachmentDto>this.attachment;
            this.paymentInfo = data.paymentInfo && !(<any>data.paymentInfo).toJSON ? new IncentivePaymentInfoDto(data.paymentInfo) : <IncentivePaymentInfoDto>this.paymentInfo;
            this.proposal = data.proposal && !(<any>data.proposal).toJSON ? new IncentiveProposalInfoDto(data.proposal) : <IncentiveProposalInfoDto>this.proposal;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.employeeId = _data["employeeId"];
            this.employmentId = _data["employmentId"];
            this.unitId = _data["unitId"];
            this.positionId = _data["positionId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.info = _data["info"];
            this.amount = _data["amount"];
            this.taxableAmount = _data["taxableAmount"];
            this.frequency = _data["frequency"] ? EnumValueDto.fromJS(_data["frequency"]) : <any>undefined;
            this.type = _data["type"] ? EnumValueDto.fromJS(_data["type"]) : <any>undefined;
            this.category = _data["category"];
            this.enteredTime = _data["enteredTime"] ? new Date(_data["enteredTime"].toString()) : <any>undefined;
            this.enteredUserId = _data["enteredUserId"];
            this.superseded = _data["superseded"] ? SupersededDto.fromJS(_data["superseded"]) : <any>undefined;
            this.isProposal = _data["isProposal"];
            this.attachment = _data["attachment"] ? RewardAttachmentDto.fromJS(_data["attachment"]) : <any>undefined;
            this.targetEarning = _data["targetEarning"];
            this.bonusValue = _data["bonusValue"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.paymentInfo = _data["paymentInfo"] ? IncentivePaymentInfoDto.fromJS(_data["paymentInfo"]) : <any>undefined;
            this.proposal = _data["proposal"] ? IncentiveProposalInfoDto.fromJS(_data["proposal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncentiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncentiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["employeeId"] = this.employeeId;
        data["employmentId"] = this.employmentId;
        data["unitId"] = this.unitId;
        data["positionId"] = this.positionId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["info"] = this.info;
        data["amount"] = this.amount;
        data["taxableAmount"] = this.taxableAmount;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["category"] = this.category;
        data["enteredTime"] = this.enteredTime ? this.enteredTime.toISOString() : <any>undefined;
        data["enteredUserId"] = this.enteredUserId;
        data["superseded"] = this.superseded ? this.superseded.toJSON() : <any>undefined;
        data["isProposal"] = this.isProposal;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        data["targetEarning"] = this.targetEarning;
        data["bonusValue"] = this.bonusValue;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        data["proposal"] = this.proposal ? this.proposal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncentiveDto {
    id: number;
    uid?: string;
    employeeId: number;
    employmentId: number;
    unitId: number;
    positionId: number;
    startDate?: Date;
    endDate?: Date;
    info?: string;
    amount?: number;
    taxableAmount?: number;
    frequency?: IEnumValueDto;
    type?: IEnumValueDto;
    category: IncentiveDtoCategory;
    enteredTime: Date;
    enteredUserId?: number;
    superseded?: ISupersededDto;
    isProposal: boolean;
    attachment?: IRewardAttachmentDto;
    targetEarning?: number;
    bonusValue?: number;
    unitOfMeasure?: string;
    paymentInfo?: IIncentivePaymentInfoDto;
    proposal?: IIncentiveProposalInfoDto;
}

export class ProposalTargetDto implements IProposalTargetDto {
    uid!: string;
    category!: ProposalTargetDtoCategory;

    constructor(data?: IProposalTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): ProposalTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["category"] = this.category;
        return data;
    }
}

export interface IProposalTargetDto {
    uid: string;
    category: ProposalTargetDtoCategory;
}

export class BulkProposalActionInput implements IBulkProposalActionInput {
    proposals!: ProposalTargetDto[];

    constructor(data?: IBulkProposalActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.proposals) {
                this.proposals = [];
                for (let i = 0; i < data.proposals.length; i++) {
                    let item = data.proposals[i];
                    this.proposals[i] = item && !(<any>item).toJSON ? new ProposalTargetDto(item) : <ProposalTargetDto>item;
                }
            }
        }
        if (!data) {
            this.proposals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["proposals"])) {
                this.proposals = [] as any;
                for (let item of _data["proposals"])
                    this.proposals!.push(ProposalTargetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkProposalActionInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkProposalActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.proposals)) {
            data["proposals"] = [];
            for (let item of this.proposals)
                data["proposals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulkProposalActionInput {
    proposals: IProposalTargetDto[];
}

export enum Order {
    Asc = "asc",
    Desc = "desc",
}

export enum Order2 {
    Asc = "asc",
    Desc = "desc",
}

export enum WorkflowStatuses {
    PROPOSED = "PROPOSED",
    MANAGER_APPROVED = "MANAGER_APPROVED",
    MANAGER_REJECTED = "MANAGER_REJECTED",
    HR_APPROVED = "HR_APPROVED",
    HR_REJECTED = "HR_REJECTED",
    COMPLETED = "COMPLETED",
    CLOSED = "CLOSED",
    FAILED = "FAILED",
}

export enum Order3 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order4 {
    Asc = "asc",
    Desc = "desc",
}

export enum WorkflowStatuses2 {
    PROPOSED = "PROPOSED",
    MANAGER_APPROVED = "MANAGER_APPROVED",
    MANAGER_REJECTED = "MANAGER_REJECTED",
    HR_APPROVED = "HR_APPROVED",
    HR_REJECTED = "HR_REJECTED",
    COMPLETED = "COMPLETED",
    CLOSED = "CLOSED",
    FAILED = "FAILED",
}

export enum Order5 {
    Asc = "asc",
    Desc = "desc",
}

export enum Order6 {
    Asc = "asc",
    Desc = "desc",
}

export enum WorkflowStatuses3 {
    PROPOSED = "PROPOSED",
    MANAGER_APPROVED = "MANAGER_APPROVED",
    MANAGER_REJECTED = "MANAGER_REJECTED",
    HR_APPROVED = "HR_APPROVED",
    HR_REJECTED = "HR_REJECTED",
    COMPLETED = "COMPLETED",
    CLOSED = "CLOSED",
    FAILED = "FAILED",
}

export enum Order7 {
    Asc = "asc",
    Desc = "desc",
}

export enum Categories {
    INCENTIVE_SHORT = "INCENTIVE_SHORT",
    INCENTIVE_SHORT_PAID = "INCENTIVE_SHORT_PAID",
    INCENTIVE_LONG = "INCENTIVE_LONG",
    INCENTIVE_LONG_PAID = "INCENTIVE_LONG_PAID",
}

export enum Order8 {
    Asc = "asc",
    Desc = "desc",
}

export enum WorkflowStatuses4 {
    PROPOSED = "PROPOSED",
    MANAGER_APPROVED = "MANAGER_APPROVED",
    MANAGER_REJECTED = "MANAGER_REJECTED",
    HR_APPROVED = "HR_APPROVED",
    HR_REJECTED = "HR_REJECTED",
    COMPLETED = "COMPLETED",
    CLOSED = "CLOSED",
    FAILED = "FAILED",
}

export enum Action {
    Approve = "approve",
    Reject = "reject",
}

export class SalaryListResultDto implements ISalaryListResultDto {
    data!: SalaryDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ISalaryListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new SalaryDto(item) : <SalaryDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SalaryDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): SalaryListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ISalaryListResultDto {
    data: ISalaryDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class SalaryListResultDto2 implements ISalaryListResultDto2 {
    data!: SalaryDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ISalaryListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new SalaryDto(item) : <SalaryDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SalaryDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): SalaryListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ISalaryListResultDto2 {
    data: ISalaryDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class AllowanceListResultDto implements IAllowanceListResultDto {
    data!: AllowanceDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAllowanceListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AllowanceDto(item) : <AllowanceDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AllowanceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AllowanceListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAllowanceListResultDto {
    data: IAllowanceDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class AllowanceListResultDto2 implements IAllowanceListResultDto2 {
    data!: AllowanceDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IAllowanceListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AllowanceDto(item) : <AllowanceDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AllowanceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): AllowanceListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IAllowanceListResultDto2 {
    data: IAllowanceDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class BenefitListResultDto implements IBenefitListResultDto {
    data!: BenefitDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IBenefitListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new BenefitDto(item) : <BenefitDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BenefitDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): BenefitListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IBenefitListResultDto {
    data: IBenefitDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class BenefitListResultDto2 implements IBenefitListResultDto2 {
    data!: BenefitDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IBenefitListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new BenefitDto(item) : <BenefitDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BenefitDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): BenefitListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IBenefitListResultDto2 {
    data: IBenefitDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class IncentiveListResultDto implements IIncentiveListResultDto {
    data!: IncentiveDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IIncentiveListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new IncentiveDto(item) : <IncentiveDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IncentiveDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): IncentiveListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncentiveListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IIncentiveListResultDto {
    data: IIncentiveDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class IncentiveListResultDto2 implements IIncentiveListResultDto2 {
    data!: IncentiveDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IIncentiveListResultDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new IncentiveDto(item) : <IncentiveDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IncentiveDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): IncentiveListResultDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new IncentiveListResultDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IIncentiveListResultDto2 {
    data: IIncentiveDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export enum SalaryDtoCategory {
    SALARY = "SALARY",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    ALLOWANCE = "ALLOWANCE",
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT = "BENEFIT",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    INCENTIVE_SHORT = "INCENTIVE_SHORT",
    INCENTIVE_SHORT_PROPOSAL = "INCENTIVE_SHORT_PROPOSAL",
    INCENTIVE_SHORT_PAID = "INCENTIVE_SHORT_PAID",
    INCENTIVE_LONG = "INCENTIVE_LONG",
    INCENTIVE_LONG_PAID = "INCENTIVE_LONG_PAID",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BILLABLE_HOURS_PROPOSAL = "BILLABLE_HOURS_PROPOSAL",
    BILLABLE_HOURS_PAID = "BILLABLE_HOURS_PAID",
}

export enum AllowanceDtoCategory {
    SALARY = "SALARY",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    ALLOWANCE = "ALLOWANCE",
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT = "BENEFIT",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    INCENTIVE_SHORT = "INCENTIVE_SHORT",
    INCENTIVE_SHORT_PROPOSAL = "INCENTIVE_SHORT_PROPOSAL",
    INCENTIVE_SHORT_PAID = "INCENTIVE_SHORT_PAID",
    INCENTIVE_LONG = "INCENTIVE_LONG",
    INCENTIVE_LONG_PAID = "INCENTIVE_LONG_PAID",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BILLABLE_HOURS_PROPOSAL = "BILLABLE_HOURS_PROPOSAL",
    BILLABLE_HOURS_PAID = "BILLABLE_HOURS_PAID",
}

export enum BenefitDtoCategory {
    SALARY = "SALARY",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    ALLOWANCE = "ALLOWANCE",
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT = "BENEFIT",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    INCENTIVE_SHORT = "INCENTIVE_SHORT",
    INCENTIVE_SHORT_PROPOSAL = "INCENTIVE_SHORT_PROPOSAL",
    INCENTIVE_SHORT_PAID = "INCENTIVE_SHORT_PAID",
    INCENTIVE_LONG = "INCENTIVE_LONG",
    INCENTIVE_LONG_PAID = "INCENTIVE_LONG_PAID",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BILLABLE_HOURS_PROPOSAL = "BILLABLE_HOURS_PROPOSAL",
    BILLABLE_HOURS_PAID = "BILLABLE_HOURS_PAID",
}

export enum IncentiveDtoCategory {
    SALARY = "SALARY",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    ALLOWANCE = "ALLOWANCE",
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT = "BENEFIT",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    INCENTIVE_SHORT = "INCENTIVE_SHORT",
    INCENTIVE_SHORT_PROPOSAL = "INCENTIVE_SHORT_PROPOSAL",
    INCENTIVE_SHORT_PAID = "INCENTIVE_SHORT_PAID",
    INCENTIVE_LONG = "INCENTIVE_LONG",
    INCENTIVE_LONG_PAID = "INCENTIVE_LONG_PAID",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BILLABLE_HOURS_PROPOSAL = "BILLABLE_HOURS_PROPOSAL",
    BILLABLE_HOURS_PAID = "BILLABLE_HOURS_PAID",
}

export enum ProposalTargetDtoCategory {
    SALARY = "SALARY",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    ALLOWANCE = "ALLOWANCE",
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT = "BENEFIT",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    INCENTIVE_SHORT = "INCENTIVE_SHORT",
    INCENTIVE_SHORT_PROPOSAL = "INCENTIVE_SHORT_PROPOSAL",
    INCENTIVE_SHORT_PAID = "INCENTIVE_SHORT_PAID",
    INCENTIVE_LONG = "INCENTIVE_LONG",
    INCENTIVE_LONG_PAID = "INCENTIVE_LONG_PAID",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BILLABLE_HOURS_PROPOSAL = "BILLABLE_HOURS_PROPOSAL",
    BILLABLE_HOURS_PAID = "BILLABLE_HOURS_PAID",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}